import http from '@/axios/http'
import { getuser_id } from "@/localStorage/localStorage";
//获取配置文件列表
export function listConfigurationFile(offset, limit) {
    const data = {
        user_id: getuser_id(),
        offset: offset,
        limit: limit
    }
    return http({
        url: '/api/configurationFileManager/listConfigurationFile',
        method: 'post',
        data
    })
}
//删除配置文件
export function delConfigurationFile(id) {
    const data = {
        id: id
    }
    return http({
        url: '/api/configurationFileManager/delConfigurationFile',
        method: 'post',
        data
    })
}
//查询排序
export function queryKeyword(keyword, offset, limit, sort) {
    const data = {
        user_id: getuser_id(),
        keyword: keyword,
        offset: offset,
        limit: limit,
        name: sort.cfName,
        size: sort.cfSize,
        username: sort.username,
        create: sort.cfCreate,
        remark: sort.cfRemarks
    }
    return http({
        url: '/api/configurationFileManager/queryKeyword',
        method: 'post',
        data
    })
}